<template>
  <div class="data-empty">暂无数据</div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style lang='scss' scoped>
.data-empty {
    display: table;
    width: 100%;
    height: 100%;
    font-size: 16px;
    color: #999;
    padding: 30px 0;
    text-align: center;
}
</style>
